import React, { useEffect, useState } from "react";
import { DropBox } from "../../../components";
import { getLanguage } from "../../../utils/environment";
import { useDispatch } from "react-redux";
import { getAllJobsCategory } from "../../CreateNewItem/CreateNewJob/service/jobs.service";
import { setJobCategoryList } from "../../Jobs/redux/actions";

const lan = getLanguage();

const Index = ({ data, onChangeCategory }) => {
  const [language, setLanguage] = useState("");
  const [formData, setFormData] = useState({
    organization: {
      key: "organization",
      label: "Organization",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();

  const fetchCategories = async () => {
    const updateForm = { ...formData };
    updateForm.organization.loading = true;
    updateForm["organization"].elementConfig.options = [];
    const response = await getAllJobsCategory();
    if (response?.data) {
      let categoryList = await syncCategory(response.data);
      updateForm["organization"].elementConfig.options = categoryList;
      updateForm.organization.loading = false;
      dispatch(setJobCategoryList(response.data));

      setFormData(updateForm);
    }
  };

  const syncCategory = async (res) => {
    let categoryList = [];

    for (let organization of res) {
      categoryList.push({
        id: organization.job_category_id,

        key: organization.jobs_category_name,
        value: organization.job_category_id,

        // key: organization.job_category_id,
        // value: organization.jobs_category_name,

        displayValue: organization.jobs_category_name,
      });
    }
    return categoryList;
  };

  useEffect(() => {
    if (formData.organization.elementConfig.options.length === 0) {
      fetchCategories();
    }
  }, []);

  useEffect(() => {
    if (data && data.language && data.language !== language) {
      setLanguage(data.language);
      fetchCategories();
    }
  }, [data]);

  const updateNewsForm = { ...formData };

  return (
    <>
      <DropBox
        data={updateNewsForm.organization}
        onChange={(e) => {
          const updateForm = { ...formData };
          updateForm["organization"].value = e;
          setFormData(updateForm);
          console.log("Category Select Box:", e);
          onChangeCategory(e);
        }}
      />
    </>
  );
};

export default Index;
